





















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Picker, Popup } from 'vant';
Vue.use(Picker).use(Popup);
@Component
export default class PickerInput extends Vue {
  @Prop() PickerData!: object;
  @Prop({ default: '请选择' }) placeholder!: string;
  @Prop() value: string = '';
  showPicker: boolean = false;
  startPicker() {
    console.log('object');
    this.showPicker = true;
  }
  onConfirm(e: string, index: number) {
    this.$emit('selectData', e, index);
    this.value = e;
    this.showPicker = false;
  }
}
